module.exports = __webpack_public_path__ + "static/media/company-logo-placeholder.156a8b71.png";